import { Inject, Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { ENVIRONMENT } from "../modules/keycloak.module";
import type { IEnvironment } from "../models/interfaces/environment.interface";
import { UserStore } from "../stores/user.store";

@Injectable({ providedIn: "root" })
export class HeadersInterceptor<T> implements HttpInterceptor {
  private readonly HEADERS = this.environment.APP_CONFIGURATION.HEADERS;

  constructor(
    @Inject(ENVIRONMENT) private readonly environment: IEnvironment,
    private readonly userStore: UserStore
  ) {}

  intercept(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (!this.isApiRequest(req.url)) {
      return next.handle(req);
    }

    const user = this.userStore.user();
    const jwt = this.userStore.jwt();
    const setHeaders: Record<string, string> = {
      "X-Api-Key": this.environment.APIKEY,
      "X-Chref": this.HEADERS["CHREF"],
      "X-Commerce": this.HEADERS["COMMERCE"],
      "x-cmref": this.HEADERS["CMREF"],
      "x-country": user?.country.toUpperCase() ?? "",
    };

    if (jwt) {
      setHeaders["Authorization"] = `Bearer ${jwt}`;
    }

    const modifiedReq = req.clone({
      setHeaders,
    });

    return next.handle(modifiedReq);
  }

  private isApiRequest(url: string): boolean {
    const baseUrl = this.environment.BASE_URL;

    return url.startsWith("/v1/") || url.startsWith("/api/") || (!!baseUrl && url.startsWith(baseUrl));
  }
}
